import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { AccordionModule, ButtonModule } from '@com-delta-idp/mnx-ui-kit';
import { PersonalProfileSelectorView } from './models/personal-profile-selector.interface';

@Component({
  selector: 'idp-personal-profile-selector',
  standalone: true,
  templateUrl: './personal-profile-selector.component.html',
  styleUrls: ['./personal-profile-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, ButtonModule, AccordionModule]
})
export class PersonalProfileSelectorComponent implements OnInit {
  @Input() pageData = {} as PersonalProfileSelectorView;
  @Input() personalStateSelected = false;
  @Output() personalProfileSelected = new EventEmitter();
  active = this.personalStateSelected;

  ngOnInit() {
    this.active = this.personalStateSelected;
  }

  onClick(title: string, firstName: string): void {
    this.personalProfileSelected.emit({ title, firstName });
    this.active = this.personalStateSelected;
  }
}
